import React, { useMemo, useState } from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import Select, { components } from "react-select";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import cioEvent from "../../../assets/cio_icon.svg";
import {
  getAllExamCodes,
  getAllModalities,
  getAllReportCohorts,
  getRecoCohortsDropdownOptions,
  getReportCohorts,
  showAlert,
} from "../../../actions/radminUploads";
import { useEffect } from "react";
import Creatable from "react-select/creatable";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { ReactComponent as RemoveRecoIconHover } from "../../../assets/delete-hover.svg";
import { Link, useHistory } from "react-router-dom";

ReactModal.setAppElement("#root");

const Modal = styled(ReactModal)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 564px !important;
  padding: 18px 24px !important;

  height: ${({ isChecked, step }) =>
    isChecked && step === 2 ? "606x" : `fit-content !important;`};

  margin: ${({ isChecked, step }) =>
    isChecked && step !== 1 ? `5% auto` : `15% auto`};
  background: white;

  @media (max-width: 768px) {
    width: auto !important;
    margin: 30px !important;
    margin-top: calc(15% + 30px) !important;
  }
`;

const CheckboxInput = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid;
  // border-radius: 50%;
  margin-right: 16px;
  border-color: ${(props) => props.border};
  background-color: ${(props) => props.background};
  background-clip: content-box;
  cursor: pointer;
  &[type="radio"] {
    padding: 3%;
  }
`;

const RoleGroupContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margint-top: 4.5px;
  height: 16px;
  margin-bottom: 5px;
  flex-direction: column;
  margin-left: 7px;
  height: 238px;
  padding: 9px 11px;
`;

const Remove = styled.div`
  cursor: pointer;
  margin-top: 30px;
`;

const IconContainer = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 30px;
  height: 20px;

  &:hover svg:not(.light) {
    display: none;
  }

  &:hover svg.light {
    display: block;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  svg.light {
    display: none;
  }
`;

const CheckBoxLabel = styled.label`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 15px;
  padding-left: 10px;
`;

const CheckboxTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const Label = styled.label`
  align-self: flex-start;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #3f4857;
`;

const Input = styled.input.attrs({ type: "text" })`
  width: ${({ isChecked }) => (isChecked ? `10%` : `100%`)};
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c2ccd9;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #8692a4;
  height: 38px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: flex-end;
  gap: 10px;
`;

export const Image = styled.img`
  width: 20px;
  margin-left: 7px;
  color: #000000;
  fill: #000000;
`;

const SwitchContainer = styled.div`
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: fit-content;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const SwitchButton = styled.button`
  padding: 7px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  font-weight: ${(props) => (props.active ? 700 : 600)};
  border: 0;
  outline: 0;
  border-radius: 6px;
`;

const Button = styled.button`
  width: 140px;
  height: 38px;
  background: ${({ isPrimary, disabled }) =>
    disabled ? "#00AEEF4D" : isPrimary ? "#00AEEF" : "transparent"};
  border-radius: 5px;
  border: ${({ isPrimary, disabled, color }) =>
    disabled
      ? "2px solid transparent"
      : isPrimary
        ? "2px solid #00AEEF"
        : `2px solid ${color ? color : "#CFCFCF"}`};
  outline: none !important;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${({ isPrimary, color }) =>
    isPrimary ? "white" : color ?? "#000000"};
  &:hover {
    background: ${({ isPrimary, color }) =>
    isPrimary ? "transparent" : color ?? "#CFCFCF"};
    color: ${({ isPrimary }) => (isPrimary ? "#00aeef" : "white")};
    border: ${({ isPrimary, disabled, color }) =>
    isPrimary
      ? "2px solid #00AEEF"
      : `2px solid ${color ? color : "#CFCFCF"}`};
  }
`;

const StyledRedirectButton = styled.span`
color: #00AEEF;
text-decoration:underline;
cursor:pointer;
`

const customStyle = {
  overlay: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(12, 41, 69, 0.38)",
    zIndex: 1,
  },
  content: {
    borderRadius: "4px",
  },
};

const tabOption = [
  { label: "Modality", value: "modality" },
  { label: "Exam Code", value: "exam_code" },
];

const IndicatorsContainer = (props) => {
  return (
    <div style={{ backgroundColor: "#FFF" }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};
const colourStyles = {
  placeholder: (styles) => ({ ...styles, fontSize: "14px" }),
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      backgroundColor: isSelected ? "#D9ECFF" : "white",
      display: "flex",
    };
  },
  multiValue: (styles, { data }) => ({
    ...styles,
    borderRadius: "25px",
    backgroundColor: "#EEEEEE",
    color: "#A1A1A1",
    padding: "4px 10px",
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "#A1A1A1",
    fontSize: "10px",
  }),
};

const statusList = [
  { "label": "Not Compliant", "value": "not_compliant" }, { label: 'Completed', value: 'completed' }, { label: 'Scheduled', value: 'scheduled' }, { label: 'Ordered', value: 'ordered' }, { label: 'Not Completed', value: 'not_completed' },
]

const CustomModal = ({
  headerTitle = "",
  inputTitle = "",
  placeholderText = "",
  onClose,
  onSave,
  opened,
  inputValue,
  setInputValue,
  showDropDown,
  isChecked,
  setIsChecked,
  redirectLink
}) => {
  const [loading, setLoading] = useState(false);
  const [savedCohortGroups, setSavedCohortGroups] = useState();
  const [modalitiesData, setModalitiesData] = useState();
  const [examCodeData, setExamCodeData] = useState();
  const history = useHistory();
  const dispatch = useDispatch();

  const permission = useSelector((state) => state.auth.user.permission_level);
  const rolePermissions = useSelector(
    (state) => state.auth.user.permissions
  );
  const addPermission = rolePermissions?.find(itm => itm.name === "Search Report Text")?.permissions.find(itm => itm.codename === "add_searchreporttext")?.is_authorized;


  const [selectedGroup, setSelectedGroup] = useState();
  const [days, setDays] = useState();
  const [step, setStep] = useState(1);
  const [selectedOption, setSelectedOption] = useState([])
  const [fields, setFields] = useState([
    {
      id: Date.now(),
    },
  ]);
  const [examFields, setExamFields] = useState([
    {
      id: Date.now(),
    },
  ]);
  const [activeTab, setActiveTab] = useState("modality");

  const hasReportSearchEventsEnabled = useSelector(
    (state) => state.auth.user.provider.report_search_event
  );

  const RadioOption = (props) => {
    return (
      <>
        <components.Option {...props}>
          <div style={{ display: "flex", gap: "5px" }}>
            <span>
              <input
                type="radio"
                checked={props.isSelected}
                onChange={() => null}
                style={{ marginTop: 5 }}
              />{" "}
            </span>
            <label>{props.label}</label>
            {props?.data?.trigger_cio_event && hasReportSearchEventsEnabled ? (
              <span>
                <Image src={cioEvent} alt={"settings icon"} />
              </span>
            ) : null}
          </div>
        </components.Option>
      </>
    );
  };

  const modalitiesFilter = Array.isArray(fields)
  ? fields
      .filter(item =>
        item?.report2_modality?.value !== undefined &&
        item?.report2_modality?.value !== null &&
        item?.report2_modality?.value !== '' &&
        item?.subsequent_modality?.value !== undefined &&
        item?.subsequent_modality?.value !== null &&
        item?.subsequent_modality?.value !== ''
      ).map((item) => ({ "report2_modality": item?.report2_modality?.value, "subsequent_modality": item?.subsequent_modality?.value }))
  : [];
  const validExamCodeFilter = Array.isArray(examFields)
  ? examFields
      .filter(item =>
        item?.report2_exam_code?.value !== undefined &&
        item?.report2_exam_code?.value !== null &&
        item?.report2_exam_code?.value !== '' &&
        item?.subsequent_exam_code?.value !== undefined &&
        item?.subsequent_exam_code?.value !== null &&
        item?.subsequent_exam_code?.value !== ''
      )
      .map(item => ({
        report2_exam_code: item.report2_exam_code.value,
        subsequent_exam_code: item.subsequent_exam_code.value
      }))
  : [];
  const handleFilterSave = async (e) => {
    if ((permission && addPermission) || !permission) {

      const conversionTrackingData = {
        "computed_status_filter": selectedOption,
        "days": days,
        modality_mappings:
      activeTab === "modality" && modalitiesFilter && modalitiesFilter.length > 0
        ? modalitiesFilter
        : [],
      exam_code_mappings:
      activeTab === "exam_code" && validExamCodeFilter && validExamCodeFilter.length > 0
        ? validExamCodeFilter
        : []
      }
      e.preventDefault();
      setLoading(true);
      onSave(selectedGroup, conversionTrackingData, inputValue);
      setLoading(false);
    } else {
      dispatch(
        showAlert('danger', 'Error', `You don't have permission to add search report cohort`)
      );
    }

  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };


  useEffect(() => {
    dispatch(getAllReportCohorts()).then((res) => {
      if (res) {
        setSavedCohortGroups(
          res?.results?.map((itm) => ({
            ...itm,
            label: itm.title,
            value: itm.id,
          }))
        );
      }
    });

    dispatch(getAllModalities()).then((res) => {
      if (res) {

        setModalitiesData(
          res?.filter((itm) => itm.modality !== '').map((itm) => ({ label: itm.modality, value: itm.modality }))
        )
      }
    })
    dispatch(getAllExamCodes()).then((res) => {
      if(res) {
        setExamCodeData(
          res?.filter((itm) => itm.exam_code !== '').map((itm) => ({ label: itm.exam_code, value: itm.exam_code }))
        ) 
      }
    })
  }, []);

  const handleOptionChange = (event) => {
    const value = event.target.value;
    if (selectedOption.includes(value)) {
      setSelectedOption(selectedOption.filter((item) => item !== value));
    } else {
      setSelectedOption([...selectedOption, value]);
    }
  };

  const isButtonDisabled = useMemo(() => {
    const allHaveInitialModality = fields?.every((item) =>
      item?.report2_modality &&
      item?.subsequent_modality &&
      typeof item.report2_modality === 'object' &&
      typeof item.subsequent_modality === 'object' &&
      Object.keys(item.report2_modality).length > 0 &&
      Object.keys(item.subsequent_modality).length > 0
    );

    const allHaveInitialExamCode = examFields?.every((item) =>
      item?.report2_exam_code &&
      item?.subsequent_exam_code &&
      typeof item.report2_exam_code === 'object' &&
      typeof item.subsequent_exam_code === 'object' &&
      Object.keys(item.report2_exam_code).length > 0 &&
      Object.keys(item.subsequent_exam_code).length > 0
    );

    if (step === 2 && days && activeTab === 'modality' && allHaveInitialModality) {
      return false;
    }
    if(step === 2 && days && activeTab === 'exam_code' && allHaveInitialExamCode) {
     return false;
    }
    if (step === 1 &&
      isChecked &&
      inputValue
    ) {
      return false;
    }
    if (!isChecked && inputValue) {
      return false;
    }
    if (!isChecked && selectedGroup) {
      return false;
    }

    return true;
  }, [
    isChecked,
    inputValue,
    days,
    step,
    fields,
    examFields,
    activeTab,
    selectedGroup
  ]);

  const handleChangeAnatomy = (newValue, actionMeta) => {
    if (actionMeta.action === "create-option") {
      const newOption = { value: newValue?.value, label: newValue?.label };
      setSavedCohortGroups((prevOptions) => [...prevOptions, newOption]);
    }
    setSelectedGroup(newValue);
    setInputValue(newValue?.value);

    if (newValue?.trigger_cio_event) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };

  const handleAddMore = () => {
    setFields([
      ...fields,
      { id: Date.now() },
    ]);
  };

  const handleAddMoreExamCode = () => {
    setExamFields([
      ...examFields,
      { id: Date.now() },
    ]);
  };

  const handleRemove = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  const handleRemoveExamCode = (id) => {
    setExamFields(examFields.filter((f) => f.id !== id));
  };


  const handleChange = (id, type, selectedOption) => {
    setFields((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [type]: selectedOption } : item
      )
    );

  };

  const handleChangeExamCode = (id, type, selectedOption) => {
    setExamFields((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [type]: selectedOption } : item
      )
    );

  };

  return (
    <Modal
      style={customStyle}
      isOpen={opened}
      isChecked={isChecked}
      step={step}
      onRequestClose={onClose}
      contentLabel="Save Filter Set"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "100%",
          paddingLeft: '10px'
        }}
      >
        {redirectLink ? <h2
          style={{
            fontSize: "24px",
            color: "#0C2945",
            fontWeight: 700,
            fontFamily: "Roboto Condensed",
          }}
        >
          {'View Cohort Reports'}
        </h2>
          : step === 1 ? (
            <h2
              style={{
                fontSize: "24px",
                color: "#0C2945",
                fontWeight: 700,
                fontFamily: "Roboto Condensed",
              }}
            >
              {headerTitle}
            </h2>
          ) : (
            <div
              style={{
                color: "#0C2945",
                fontFamily: "Roboto Condensed",
              }}
            >
              <h4 style={{ fontSize: "24px", fontWeight: "bold" }}>
                Conversion Tracking
              </h4>
              <p
              >
                {step === 2 &&
                  `Please indicate how you'd like to track the conversion and success`}
                {step === 3 &&
                  `Please indicate which status(es) you'd like to include in the cohort`}
              </p>
            </div>
          )}
        <div>
          <p
            style={{
              cursor: "pointer",
              fontSize: step === 1 ? "1rem" : "1rem",
            }}
            onClick={onClose}
          >
            x
          </p>
        </div>
      </div>
      {
        redirectLink ? <div>
          <StyledRedirectButton onClick={() => {
            history.push(`/auth/radAdmin/followUp/reports/cohorts/details/${redirectLink?.id}`, {
              data: redirectLink,
            });
          }} >Click to view created cohort reports</StyledRedirectButton>
        </div> : <form style={{ width: "100%" }} onSubmit={handleFilterSave}>
          {step === 1 ? (
            <div style={{paddingLeft: '10px'}}>
              {showDropDown ? (
                <>
                  <div style={{ minWidth: "270px" }}>
                    <Label children="Select Cohort" />
                    <Creatable
                      isClearable={true}
                      onChange={handleChangeAnatomy}
                      options={savedCohortGroups}
                      value={selectedGroup}
                      placeholder="Type or Select..."
                      components={{
                        IndicatorsContainer,
                        Option: RadioOption,
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        option: (styles) => ({
                          ...styles,
                          fontSize: "14px",
                        }),
                      }}
                    />
                  </div>
                </>
              ) : (
                <div>
                  <Label children={inputTitle} htmlFor="filterSet" />
                  <Input
                    onChange={(e) => setInputValue(e.target.value)}
                    value={inputValue}
                    id="filterSet"
                    placeholder={placeholderText}
                  />
                </div>
              )}
              {hasReportSearchEventsEnabled && (
                <div style={{ marginTop: "20px" }}>
                  <CheckBoxLabel>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <CheckboxTitle>Add to Messaging Campaign</CheckboxTitle>
                  </CheckBoxLabel>
                </div>
              )}
            </div>
          ) : step === 2 ? (
            <div
              style={{
                height: "400px",
                overflowY: "auto",
                paddingLeft: '10px'
              }}
            >
              <div>
                <Label
                  children={"DAYS UNTIL SUBSEQUENT REPORT(<= 450)*"}
                  htmlFor="filterSet"
                />
                <br />
                <Input
                  min={0}
                  type="number"
                  max={450}
                  isChecked={isChecked}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (!/^\d*$/.test(input)) {
                      setDays("");
                    }

                    if (input >= 0 && input <= 450) {
                      setDays(input);
                    } else if (input === "") {
                      setDays("");
                    }
                  }}
                  value={days}
                  id="filterSet"
                  placeholder={""}
                />
              </div>
               <Label
                  children={"Select Either Modality or Exam Code to add mappings"}
                  htmlFor="filterSet"
                />
              <SwitchContainer>
        {tabOption.map((tab) => (
          <SwitchButton
          type="button"
            active={activeTab === tab.value}
            onClick={() => {
              setActiveTab(tab.value);
             if(tab.value === 'exam_code' && (!examFields[0]?.report2_exam_code || !examFields[0]?.subsequent_exam_code) ) {
              setExamFields([{ id: Date.now() }]);
              }
              if(tab.value === 'modality' && (!fields[0]?.report2_modality || !fields[0]?.subsequent_modality)) {
              setFields([{ id: Date.now() }]);
              }
            }}
          >
            {tab.label}
          </SwitchButton>
        ))}
            </SwitchContainer>
              {
                activeTab === "modality" ? (
                  <div>
                {fields.map((field, index) => (
                  <div
                    key={field.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "5px",
                      paddingLeft: '10px'
                    }}
                  >
                    <div style={{ minWidth: "200px" }}>
                      <Label children="INITIAL MODALITY*" />
                      <Creatable
                        isClearable={true}
                        onChange={(val) =>
                          handleChange(field.id, "report2_modality", val)
                        }
                        options={modalitiesData}
                        value={field.report2_modality}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>

                    <div style={{ minWidth: "200px" }}>
                      <Label children="SUBSEQUENT MODALITY*" />
                      <Creatable
                        isClearable={true}
                        options={modalitiesData}
                        onChange={(val) =>
                          handleChange(field.id, "subsequent_modality", val)
                        }
                        value={field.subsequent_modality}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>
                    {fields.length !== 1 && (
                      <Remove onClick={() => handleRemove(field.id)}>
                        <IconContainer>
                          <RemoveRecoIcon />
                          <RemoveRecoIconHover className="light" />
                        </IconContainer>
                      </Remove>
                    )}
                  </div>
                ))}
              </div>
                ) : (
                   <div>
                {examFields.map((field, index) => (
                  <div
                    key={field.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      marginTop: "5px",
                      paddingLeft: '10px'
                    }}
                  >
                    <div style={{ minWidth: "200px" }}>
                      <Label children="INITIAL EXAM CODE*" />
                      <Creatable
                        isClearable={true}
                        onChange={(val) =>
                          handleChangeExamCode(field.id, "report2_exam_code", val)
                        }
                        options={examCodeData}
                        value={field.report2_exam_code}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>

                    <div style={{ minWidth: "200px" }}>
                      <Label children="SUBSEQUENT EXAM CODE*" />
                      <Creatable
                        isClearable={true}
                        options={examCodeData}
                        onChange={(val) =>
                          handleChangeExamCode(field.id, "subsequent_exam_code", val)
                        }
                        value={field.subsequent_exam_code}
                        placeholder="Select..."
                        components={{
                          IndicatorsContainer,
                          Option: RadioOption,
                        }}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={{
                          option: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div>
                    {examFields.length !== 1 && (
                      <Remove onClick={() => handleRemoveExamCode(field.id)}>
                        <IconContainer>
                          <RemoveRecoIcon />
                          <RemoveRecoIconHover className="light" />
                        </IconContainer>
                      </Remove>
                    )}
                  </div>
                ))}
                  </div>
                )
              }
              </div>
          ) : step === 3 ? (
            statusList?.map((status) => (
              <CheckBoxLabel key={status.value}>
                <input
                  type="checkbox"
                  value={status.value}
                  style={{ height: '20px', width: '20px' }}
                  checked={selectedOption.includes(status.value)}
                  onChange={handleOptionChange}
                />
                <span className="custom-checkbox" />
                <CheckboxTitle>{status.label}</CheckboxTitle>
              </CheckBoxLabel>
            ))
          ) : null}

          <ButtonContainer isChecked={isChecked}>
            <Button onClick={onClose} children="Cancel" />

            {isChecked && (step === 2) && (
              <>
                <Button
                  type="button"
                  onClick={step === 2 && activeTab === 'modality' ? handleAddMore : handleAddMoreExamCode}
                  color="#00AEEF"
                  children="Add More"
                />
              </>
            )}

            {isChecked && (step === 1 || step === 2) && (
              <Button
                type="button"
                onClick={() => setStep((prev) => prev + 1)}
                isPrimary={true}
                disabled={isButtonDisabled}
                children="Next"
              />
            )}

            {((step === 1) || (isChecked && step === 3)) && (
              <Button
                type="submit"
                isPrimary={true}
                disabled={!inputValue && !selectedGroup}
                children={
                  loading ? (
                    <Spinner animation="border" role="status" size="sm" />
                  ) : (
                    "Save"
                  )
                }
              />
            )}
          </ButtonContainer>
        </form>
      }

    </Modal>
  );
};

export default CustomModal;
